<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © e-stock.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Développer par  BTS Cooporation
                </div>
            </div>
        </div>
    </div>
</footer>